import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';
import { useTheme } from '../../../contexts/ThemeContext';

/**
 * Creators Orders - View and manage customer orders
 */
export const Route = createFileRoute('/_authenticated/creators/orders')({
  component: CreatorsOrders,
});

function CreatorsOrders() {
  const [orders] = useState<any[]>([]);
  const { theme } = useTheme();

  const colors = {
    dark: {
      text: '#ffffff',
      textMuted: '#9ca3af',
      cardBg: 'linear-gradient(135deg, rgba(26, 26, 46, 0.6) 0%, rgba(22, 33, 62, 0.6) 100%)',
      cardBorder: 'rgba(102, 126, 234, 0.2)',
      dashedBorder: 'rgba(102, 126, 234, 0.3)',
      tableBg: 'rgba(15, 15, 20, 0.4)',
      tableHeaderBg: 'rgba(26, 26, 46, 0.6)'
    },
    light: {
      text: '#111827',
      textMuted: '#6b7280',
      cardBg: '#ffffff',
      cardBorder: '#e5e7eb',
      dashedBorder: '#e5e7eb',
      tableBg: '#ffffff',
      tableHeaderBg: '#f9fafb'
    }
  };

  const c = colors[theme];

  return (
    <div style={{ padding: '2rem' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        {/* Header */}
        <div style={{ marginBottom: '2rem' }}>
          <h1 style={{
            fontSize: '2rem',
            fontWeight: 'bold',
            color: c.text,
            marginBottom: '0.5rem'
          }}>
            Orders
          </h1>
          <p style={{ color: c.textMuted, fontSize: '1rem' }}>
            View and manage customer orders for your products
          </p>
        </div>

        {/* Orders Table */}
        {orders.length === 0 ? (
          <div style={{
            background: c.cardBg,
            border: `2px dashed ${c.dashedBorder}`,
            borderRadius: '0.5rem',
            padding: '3rem',
            textAlign: 'center',
            backdropFilter: theme === 'dark' ? 'blur(10px)' : 'none'
          }}>
            <p style={{
              fontSize: '1.125rem',
              color: c.textMuted,
              marginBottom: '1rem'
            }}>
              No orders yet
            </p>
            <p style={{
              fontSize: '0.875rem',
              color: c.textMuted,
              opacity: 0.7
            }}>
              Orders for your products will appear here
            </p>
          </div>
        ) : (
          <div style={{
            background: c.tableBg,
            border: `1px solid ${c.cardBorder}`,
            borderRadius: '0.5rem',
            overflow: 'hidden',
            backdropFilter: theme === 'dark' ? 'blur(10px)' : 'none'
          }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead style={{ background: c.tableHeaderBg }}>
                <tr>
                  <th style={{ padding: '0.75rem 1rem', textAlign: 'left', fontSize: '0.75rem', fontWeight: '600', color: c.textMuted, textTransform: 'uppercase' }}>Order ID</th>
                  <th style={{ padding: '0.75rem 1rem', textAlign: 'left', fontSize: '0.75rem', fontWeight: '600', color: c.textMuted, textTransform: 'uppercase' }}>Customer</th>
                  <th style={{ padding: '0.75rem 1rem', textAlign: 'left', fontSize: '0.75rem', fontWeight: '600', color: c.textMuted, textTransform: 'uppercase' }}>Product</th>
                  <th style={{ padding: '0.75rem 1rem', textAlign: 'left', fontSize: '0.75rem', fontWeight: '600', color: c.textMuted, textTransform: 'uppercase' }}>Amount</th>
                  <th style={{ padding: '0.75rem 1rem', textAlign: 'left', fontSize: '0.75rem', fontWeight: '600', color: c.textMuted, textTransform: 'uppercase' }}>Date</th>
                  <th style={{ padding: '0.75rem 1rem', textAlign: 'left', fontSize: '0.75rem', fontWeight: '600', color: c.textMuted, textTransform: 'uppercase' }}>Status</th>
                </tr>
              </thead>
              <tbody>
                {orders.map((order) => (
                  <tr key={order.id} style={{ borderTop: `1px solid ${c.cardBorder}` }}>
                    <td style={{ padding: '1rem', fontSize: '0.875rem', color: c.text }}>{order.id}</td>
                    <td style={{ padding: '1rem', fontSize: '0.875rem', color: c.text }}>{order.customer}</td>
                    <td style={{ padding: '1rem', fontSize: '0.875rem', color: c.text }}>{order.product}</td>
                    <td style={{ padding: '1rem', fontSize: '0.875rem', color: c.text }}>${order.amount}</td>
                    <td style={{ padding: '1rem', fontSize: '0.875rem', color: c.textMuted }}>{order.date}</td>
                    <td style={{ padding: '1rem' }}>
                      <span style={{
                        padding: '0.25rem 0.75rem',
                        borderRadius: '9999px',
                        fontSize: '0.75rem',
                        fontWeight: '600',
                        backgroundColor: '#d1fae5',
                        color: '#065f46'
                      }}>
                        {order.status}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
